import React, { useEffect, useState } from 'react';
import Main from '../Main';
import { Box } from '@mui/material';
import DataTable from '../Table/DataTable';
import { homeSlideColumns } from '../Table/TableColumns';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import BackupTableIcon from '@mui/icons-material/BackupTable';
import { useDispatch, useSelector } from 'react-redux';
import AddHomeSlide from './AddHomeSlide.js';
import { clearData, getAllHomeSlide } from '../../../Redux/HomeSlideRedux.js';

function HomeSlide() {
  const dispatch = useDispatch();
  const [showForm, setShowForm] = useState(false);
  const user = JSON.parse(localStorage.getItem('user'));

  const { allHomeSlide, newHomeSlide, statusUpdate } = useSelector(
    (state) => state.homeSlideRedux
  );

  useEffect(() => {
    const adminId = user.userId;
    dispatch(getAllHomeSlide(adminId));
  }, [dispatch, newHomeSlide, statusUpdate,showForm]);

  const handleButtonClick = () => {
    if (showForm) {
      dispatch(clearData());
    }
    setShowForm((prevShowForm) => !prevShowForm);
  };

  const rows = Array.isArray(allHomeSlide)
    ? allHomeSlide.map((homeSlide, index) => {
        return {
          id: homeSlide._id,
          sNo: index + 1,
          title: homeSlide.title,
          images: homeSlide.images,
          description: homeSlide.description,
          isActive: homeSlide.isActive === true ? 'Yes' : 'No',
        };
      })
    : [];
  return (
    <Main>
      <Box component='main' sx={{ flexGrow: 1, p: 3 }}>
        <div className='container border p-4'>
          <div className='row'>
            <div className='col-6'></div>
            <div className='col-6 text-end'>
              <button
                type='button'
                className='btn btn-success'
                onClick={handleButtonClick}
              >
                {showForm ? (
                  <BackupTableIcon style={{ marginRight: '5px' }} />
                ) : (
                  <AddCircleIcon style={{ marginRight: '5px' }} />
                )}
                {showForm ? 'Show Table' : 'Add Home Slide'}
              </button>
            </div>
          </div>
          {showForm ? (
            <AddHomeSlide setShowForm={setShowForm} />
          ) : (
            <div className='row mt-3'>
              <div className='col-md-12'>
                <DataTable
                  setShowForm={setShowForm}
                  columns={homeSlideColumns}
                  rows={rows}
                  tableType='homeSlide'
                />
              </div>
            </div>
          )}
        </div>
      </Box>
    </Main>
  );
}

export default HomeSlide;
